import React, { useContext } from 'react'
import UserContext from '../../context/Globales/UserContext';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core';

import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import TableContainer from "@material-ui/core/TableContainer";



const useStyles = makeStyles((theme) => ({

    root: {
        background: 'white',
        backgroundColor: theme.palette.fondotitulos.main,
        marginTop: theme.spacing(8),
    },
    texto: {
        fontSize: 18,
        color: 'dark'
    },
    titulo: {
        fontWeight: 'bold',
        color: 'dark',
        fontSize: 22,

    },

}));
const CardsHeader = () => {


    const { DataOnp } = useContext(UserContext);
    const classes = useStyles();

    return (
        <TableContainer className={classes.root} component={Paper} elevation={2}  >

            <Table stickyHeader aria-label="sticky table" size="small" >

                <TableBody  >
                    {DataOnp.Antecedentes?.map((resul) => (


                        <TableRow hover >

                            <TableCell style={{ textAlign: 'justify', paddingLeft: '140px', width: '50%' }} >
                                {resul.Concepto}
                            </TableCell>
                            <TableCell style={{ textAlign: 'center' }} >
                                :
                            </TableCell>

                            <TableCell style={{ width: '880px', textAlign: 'left', fontWeight: 'bold' }} >
                                {resul.Valor}
                            </TableCell>
                        </TableRow>
                    ))}

                </TableBody>

            </Table>



        </TableContainer>

    );
}

export default CardsHeader;